var iStockUrl = "https://";
if (iStockUrl += "istock.myshopapps.com/ajax/", void 0 === iStockSelectClass) var iStockSelectClass = "#product-select, .selector-wrapper > select,  .single-option-selector, .single-option-selector__radio";
if (void 0 === iStockWraperClass) var iStockWraperClass = "form";
if (void 0 === iStockVarSelector) var iStockVarSelector = "[name=id]";
if (void 0 === iStockAllowResubscribe) var iStockAllowResubscribe = !0;
var iStockShopId = 0,
  iStockavlDtFormat = "",
  istExcludeProd = "",
  istExcludeVar = "",
  availDates = [],
  iStockProduct = {},
  iStockpHandle = "",
  iStockVariant = {},
  iStockVarIdOld = 0;

function iStockValidateEmail(a) {
  return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(a)
}

function istockGetVariant(c, a) {
  var b = !1;
  return jQuery.each(a, function (d, a) {
    a.id == c && (b = a)
  }), b
}

function istockNotifyClick(a, d = null) {
  // console.log("click")
  a.addClass("disabled"), a.attr("disabled", "disabled");
  var b = a.parents(iStockWraperClass);
  b.find(".iStock-msg").removeClass("iStock-error").hide();
  var c = b.find(".iStock-email-id").val();

  var ct_vid = "";
  var variantSelection = document.querySelector('.variant-selection');
  // Check if the element exists
  if (variantSelection) {
    // Get the value of the "variant" attribute
    var ct_vid = variantSelection.getAttribute('variant');
    // Output the variant value
    // console.log(ct_vid);
  } else {
    console.error("Element with class 'variant-selection' not found.");
  }
  // var vid = "40380006826073"
  var vname = document.querySelector('variant-selection input:checked').value;

  setTimeout(function () {
    // console.log("sssss " + ct_vid);
    // console.log("Adding :: " + iStockProduct.title + " : " + vname + " : " + c + " : " + iStockProduct.id + " : " + ct_vid), 
      null != d || iStockValidateEmail(c) ? jQuery.ajax({
      url: iStockUrl + "add_notify.php",
      data: {
        shopId: iStockShopId,
        cust: c,
        vid: ct_vid,
        pid: iStockProduct.id,
        vTitle: vname,
        pTitle: iStockProduct.title
      },
      dataType: "jsonp",
      jsonpCallback: "iStockAddNotifyCallback",
      success: function (a) {
        0 != a.insertId && (b.find(".iStock-msg").html(iStockSuccessMsg).show(), b.find("input.iStock-email-id").val("")), "undefined" != typeof iStockAddFn && "function" == typeof iStockAddFn && iStockAddFn()
      },
      error: function (a) { }
    }).done(function () {
      a.removeClass("disabled"), a.attr("disabled", !1)
    }) : (b.find(".iStock-msg").html(iStockErrorMsg).addClass("iStock-error").show(), setTimeout(function () {
      a.removeClass("disabled"), a.attr("disabled", !1)
    }, 500))
  }, 2000);
}

function iStockUrlParam(b) {
  var a = new RegExp("[?&]" + b + "=([^&#]*)").exec(window.location.href);
  return null != a ? a[1] || 0 : a
}

function iStockResubscribe(a) {
  var b = decodeURIComponent(iStockUrlParam("customer"));
  if ("null" != b) {
    iStockValidateEmail(b) ? (a.find(".iStock-email-id").val(b), istockNotifyClick(jQuery(a).find(".iStock-notify-btn"))) : (a.find(".iStock-email-id").attr("type", "text").val(b), istockNotifyClick(jQuery(a).find(".iStock-notify-btn"), b), a.find(".iStock-email-id").attr("type", "email").val(""));
    var c = window.location.href.split("&customer=");
    window.history.replaceState(null, null, c[0])
  }
}

function istockSetVistited(c) {
  var b = parseInt(c.find(iStockVarSelector).val()),
    a = decodeURIComponent(iStockUrlParam("customer"));
  null != b && null != a && iStockValidateEmail(a) && jQuery.ajax({
    url: iStockUrl + "set_visited.php",
    data: {
      shopId: iStockShopId,
      vid: b,
      cust: a
    },
    dataType: "jsonp",
    jsonpCallback: "iStockSetVisitedCallback",
    success: function (a) {
      // console.log("set visited : " + JSON.stringify(a.updated))
    }
  })
}

function istockNotifyShow(d, b) {
  var a = parseInt(b.find(iStockVarSelector).val());
  if (null != a && a != iStockVarIdOld) {
    var e = d.id;
    if (istExcludeProd.indexOf(e) >= 0) return;
     // console.log("product excluded ::" + e), !1;
    if (istExcludeVar.indexOf(a) >= 0) return;
     // console.log("variant excluded ::" + a), !1;
    iStockVariant = istockGetVariant(a, d.variants);
    var c = !1;
    if (iStockVariant) {
      if (iStockAllowPreorder) {
        var f = d.tags;
        "undefined" != typeof iStockVariantObj && Object.keys(iStockVariantObj).length > 0 ? "continue" == iStockVariantObj.inventory_policy && iStockVariantObj.inventory_quantity <= 0 ? c = !0 : !1 == iStockVariantObj.available && (c = !0) : -1 != f.indexOf("istock-preorder") ? c = !0 : !1 == iStockVariant.available && (c = !0)
      } else !1 == iStockVariant.available && (c = !0)
    }
    // console.log("istockNotifyShow : " + c + " :: " + a), c ? (iStockVarIdOld = a, void 0 !== availDates[a] ? ("0" == availDates[a].type ? b.find(".iStock-availability").show().find("label").show() : b.find(".iStock-availability").show().find("label").hide(), b.find(".iStock-availability").find("span").html(availDates[a].val)) : b.find(".iStock-availability").hide(), b.find(".iStock-wrapper").show(), "undefined" != typeof istockNotifyShowFn && "function" == typeof istockNotifyShowFn && istockNotifyShowFn(), iStockAllowResubscribe && iStockResubscribe(b)) : (iStockVarIdOld = 0, b.find(".iStock-wrapper").hide())
  } else iStockVarIdOld = 0, b.find(".iStock-wrapper").hide()
}

function istockgetProduct(a, b) {
  jQuery.isEmptyObject(iStockProduct) || iStockProduct.handle != a ? jQuery.getJSON("/products/" + a + ".js", function (d) {
    iStockProduct = d,
     console.log("istockgetProduct : " + iStockProduct.title);
    var c = b.find(".iStock-wrapper");
    ("" == c.attr("handle") || c.attr("handle") != a) && c.attr("handle", iStockProduct.handle), iStockProductId = iStockProduct.id, jQuery.ajax({
      url: iStockUrl + "check-availability.php",
      data: {
        shopId: iStockShopId,
        pid: iStockProductId
      },
      dataType: "jsonp",
      jsonpCallback: "iStockGetAvaildtCallback",
      success: function (a) {
        availDates = a
      }
    }).done(function () {
      istockNotifyShow(iStockProduct, b)
    })
  }) : istockNotifyShow(iStockProduct, b)
}

function istockInitQv(a, b) {
  iStockVarIdOld = 0, setTimeout(function () {
    jQuery("body").addClass("iStock-qvopen");
    var c = jQuery(iStockQvWrapper + ":visible");
    c.find(iStockVarSelector).length > 0 ? (jQuery(".iStock-wrapper").hide().find(".iStock-msg").hide(), istockgetProduct(b, c), "undefined" != typeof istockInitQvFn && "function" == typeof istockInitQvFn && istockInitQvFn()) : istockInitQv(a, b)
  }, 300)
}

function istockCloseQv() {
  jQuery("body").removeClass("iStock-qvopen"), setTimeout(function () {
    var a = jQuery(".iStock-wrapper").parents(iStockWraperClass + ":visible");
    "undefined" !== (iStockpHandle = a.find(".iStock-wrapper").attr("handle")) && istockgetProduct(iStockpHandle, a)
  }, 300)
}

function istockInit() {
  if (jQuery.fn.on && (jQuery("body").on("click", ".iStock-notify-btn", function (a) {
    // console.log('clickk');
    istockNotifyClick(jQuery(this))
  }), jQuery("body").on("change", iStockSelectClass, function () {
    jQuery(".iStock-wrapper").hide().find(".iStock-msg").hide();
    var a = jQuery(this).parents(iStockWraperClass);
    setTimeout(function () {
      istockNotifyShow(iStockProduct, a)
    }, 300)
  }), "undefined" != typeof iStockQvButton && "undefined" != typeof iStockQvWrapper && (jQuery("body").on("click", iStockQvButton, function () {
    istockInitQv(jQuery(this), jQuery(this).attr("handle"))
  }), "undefined" != typeof iStockQvCloseButton && jQuery(document).on("click", "body.iStock-qvopen", function (a) {
    (jQuery(a.target).is(iStockQvCloseButton) || jQuery(a.target).parents().not(iStockQvWrapper)) && istockCloseQv()
  }))), "undefined" != typeof Storage) {
    if (sessionStorage.iStockShop && sessionStorage.iStockShop == iStockShop) {
      if (iStockIsProductpage) {
        var a = jQuery(".iStock-wrapper").parents(iStockWraperClass + ":visible");
        "undefined" !== (iStockpHandle = a.find(".iStock-wrapper").attr("handle")) && istockgetProduct(iStockpHandle, a), istockSetVistited(a)
      }
    } else jQuery.ajax({
      url: iStockUrl + "istock_init.php",
      data: {
        shop: iStockShop
      },
      dataType: "jsonp",
      jsonpCallback: "iStockCallgetSessionback",
      success: function (a) {
        if (0 == a.length) return !1;
        if (iStockShop = sessionStorage.iStockShop = a.iStockShop, iStockShopId = sessionStorage.iStockShopId = a.iStockShopId, iStockavlDtFormat = sessionStorage.iStockavlDtFormat = a.iStockavlDtFormat, istExcludeProd = sessionStorage.istExcludeProd = a.istExcludeProd, istExcludeVar = sessionStorage.istExcludeVar = a.istExcludeVar, iStockIsProductpage) {
          var b = jQuery(".iStock-wrapper").parents(iStockWraperClass + ":visible");
          istockgetProduct(iStockpHandle = b.find(".iStock-wrapper").attr("handle"), b)
        }
      },
      error: function (a, b, c) { }
    })
  }
  "undefined" != typeof istockInitFn && "function" == typeof istockInitFn && istockInitFn()
}
"undefined" != typeof Storage && sessionStorage.iStockShop && (sessionStorage.iStockShopId && (iStockShopId = sessionStorage.iStockShopId), sessionStorage.iStockavlDtFormat && (iStockavlDtFormat = sessionStorage.iStockavlDtFormat), sessionStorage.istExcludeProd && (istExcludeProd = sessionStorage.istExcludeProd), sessionStorage.istExcludeVar && (istExcludeVar = sessionStorage.istExcludeVar)), window.addEventListener ? window.addEventListener("load", istockInit, !1) : window.attachEvent ? window.attachEvent("onload", istockInit) : window.onload = istockInit